"use strict";
import {
  DAI,
  DAI_SEPOLIA,
  USDC_MAINNET,
  USDC_SEPOLIA,
  USDR_MAINNET,
  USDR_SEPOLIA,
  USDT,
  USDT_SEPOLIA
} from "uniswap/src/constants/tokens";
import { UniverseChainId } from "uniswap/src/features/chains/types";
export const RING_USDR_TOKENS = {
  [UniverseChainId.Mainnet]: USDR_MAINNET,
  [UniverseChainId.Sepolia]: USDR_SEPOLIA
};
export const RING_MINT_STABLE_TOKENS = {
  [UniverseChainId.Mainnet]: [USDT, USDC_MAINNET, DAI],
  [UniverseChainId.Sepolia]: [USDT_SEPOLIA, USDC_SEPOLIA, DAI_SEPOLIA]
};
export const RING_EARN_STAKING_TOKENS = {
  [UniverseChainId.Sepolia]: [USDR_SEPOLIA]
};
export const RING_STABLE_MINTER_ADDRESSES = {
  [UniverseChainId.Sepolia]: "0xDc7D1b84b524E1613b831768156B3aE78b9BD2b5"
};
export const RING_FIXED_YIELD_VAULT_ADDRESSES = {
  [UniverseChainId.Sepolia]: "0xf86DD2eC204cF34B3748Fa2974048C9D53aa6D1B"
};
export const RING_FIXED_YIELD_POOL_INDEXES = {
  [UniverseChainId.Sepolia]: 1
};
export const RING_FIXED_YIELD_PROGRAM_STARTS = {
  [UniverseChainId.Sepolia]: 0
};
